import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import TradePlanCards from '../components/TradePlanCards';

export default function TradePlanningPage() {
  const { colors } = useTheme();
  const navigate   = useNavigate();

  return (
    <div className="flex flex-col pb-10" style={{ backgroundColor: colors.background }}>

      {/* Header */}
      <div className="flex items-center gap-3 px-4 pt-4 pb-3">
        <button
          onClick={() => navigate('/learning')}
          className="p-1.5 rounded-lg"
          style={{ background: 'rgba(255,255,255,0.06)', color: colors.primaryText }}
        >
          <ArrowLeft size={18} />
        </button>
        <div>
          <p style={{ fontSize: 11, fontWeight: 900, textTransform: 'uppercase', letterSpacing: '0.06em', color: '#f59e0b', marginBottom: 2 }}>
            Learning
          </p>
          <p style={{ fontSize: 18, fontWeight: 800, color: '#eceef5', letterSpacing: '-0.02em', lineHeight: 1.1 }}>
            Trade Planning
          </p>
        </div>
      </div>

      <TradePlanCards navigate={navigate} />
    </div>
  );
}
